import * as React from 'react';

import { useState } from 'react';
import {
    useSelector,
  } from 'react-redux';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import Popover from 'antd/lib/popover';
import Icon from 'antd/lib/icon';
import Tooltip from 'antd/lib/tooltip';
import Badge from 'antd/lib/badge';
import Affix from 'antd/lib/affix';
import BellIco from 'one-ui-svg/svg/bell.svg';

import { useCtx } from 'one-ui-provider';

import { NotificationCard }from './card';

import {
    NotificationModel,
} from './model';

import {
    NotificationProps,
} from './props';

import { Image_URL } from 'one-ui-image';

export const Notification = <M extends NotificationModel>(
    props: NotificationProps<M>
) => {
    const stateerror = useSelector((state: any) => (state.errorstate));
    const [notify, SetNotify] = useState(false);
    const { resolver,settings,user, static_resource_url } = useCtx();
    const { email, compatible } = settings;
    const { contact_center_type } = compatible;



  /**
   * Identify the error notification count
   */
  let copytext = "" ;

  /**
   * Build error object and user details for any error ntofication
   */

  let errorcopy = {
    loginname: "",
    loginid: "",
    mediatype: "",
    roles: "",
    teamid: "",
    teamname: "",
    teams: "",
    errorobject: stateerror?.values
  }



  if (user) {
    const userdata = user.getData();
    errorcopy.loginname = userdata.loginName;
      errorcopy.loginid = userdata.loginId;
      errorcopy.mediatype = userdata.mediaType;
      errorcopy.roles = userdata.roles;
      errorcopy.teamid = userdata.teamId;
      errorcopy.teamname = userdata.teamName;
      errorcopy.teams = userdata.teams
  }

  if (contact_center_type && contact_center_type === 'five9') {
    //This is for Five9
    let agentName = sessionStorage.getItem("agentName");
    let skillName = sessionStorage.getItem("skillName");
      errorcopy.loginname = agentName;
      errorcopy.teamname = skillName;
  }


  let emailsubject = "mailto:";
  if (email) {
    emailsubject = emailsubject + email?.mailto + "?subject=" + email?.subject + "&body=" + JSON.stringify(errorcopy)
  }

    /**
   * Identify the error notification count
   */
  let errorcount = 0;
  if (stateerror?.values) {
    errorcount = stateerror.values.length;
  }
    return (
      <>
      <Affix offsetBottom={0}>
          <Popover placement="topRight" 
                  content ={ 
                    ((errorcount > 0) && (
                      <>
                        <NotificationCard title="notification" model={{
                          errorobject: stateerror?.values
                        }} />
                          <a onClick={(e) => {
                            if (errorcount > 0) {
                              SetNotify(false);
                            }
                          }} >Close</a>
                           &nbsp;&nbsp;&nbsp;&nbsp;
                          {
                            (email?.enabled) && (
                              <>
                              <Tooltip title="Open Email">
                              <a href={emailsubject} target="_blank" rel="noopener noreferrer" >
                              <Icon type="mail" theme="filled" />
                              </a>
                            </Tooltip>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            </>
                            )
                          }
                          <Tooltip title="Copy Messages">
                            <CopyToClipboard text={JSON.stringify(errorcopy)}
                            >
                              <a><Icon type="copy" theme="filled" /> </a>
                            </CopyToClipboard>
                          </Tooltip>
                      </>))
                  }
                  title="Notifications"
                  trigger="click"
                  visible={notify}
                  onVisibleChange = {(e) => {
                    SetNotify(!notify)
                  }}
                  autoAdjustOverflow={false}>
                  <a onClick={(e) => {
                    if (errorcount > 0) {
                      SetNotify(!notify);
                    }
                  }} >
                    <Badge count={errorcount} dot>
                      <img
                        src={Image_URL(resolver(BellIco), `${static_resource_url}bell.e82f8738.svg`)}
                        width={15} height={20}
                        draggable="false"
                      />
                    </Badge>
                  </a>
                </Popover>
      </Affix>
      </>
    );
};
